import React, { useState } from "react"
import styled from "styled-components"

const StyledForm = styled.form`
  width: 100%;
  max-width: 45rem;
  margin-top: 10rem;

  .form-group {
    margin-bottom: 1.5rem;
  }

  label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.colors.text};
  }

  input,
  textarea {
    width: 100%;
    padding: 0.75rem;
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.primary};
    color: ${({ theme }) => theme.colors.text};
    background: ${({ theme }) => theme.colors.background};
    border: 0.125rem solid ${({ theme }) => theme.colors.primary};
    border-radius: ${({ theme }) => theme.borderRadius};
    transition: all 0.2s ease-out;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.primary};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.secondary};
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.subtext};
    }
  }

  textarea {
    min-height: 150px;
    resize: vertical;
  }

  button {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.background};
    background: ${({ theme }) => theme.colors.primary};
    border: 0.125rem solid ${({ theme }) => theme.colors.primary};
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    transition: all 0.2s ease-out;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px ${({ theme }) => theme.colors.boxShadow};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`

const SuccessMessage = styled.div`
  padding: 1.5rem;
  margin-top: 2rem;
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: ${({ theme }) => theme.borderRadius};
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};
`

const ErrorMessage = styled.div`
  color: #e74c3c;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  padding: 0.75rem;
  background: rgba(231, 76, 60, 0.1);
  border-radius: ${({ theme }) => theme.borderRadius};
`

function ContactForm() {
  const [status, setStatus] = useState("")
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    setSubmitting(true)

    const form = e.target
    const data = new FormData(form)

    try {
      const response = await fetch("https://formspree.io/f/xpqpglvp", {
        method: "POST",
        body: data,
        headers: {
          Accept: "application/json",
        },
      })

      if (response.ok) {
        setStatus("SUCCESS")
        form.reset()
      } else {
        setStatus("ERROR")
      }
    } catch (error) {
      setStatus("ERROR")
    }

    setSubmitting(false)
  }

  if (status === "SUCCESS") {
    return (
      <SuccessMessage>
        Thanks for reaching out! I&apos;ll get back to you soon.
      </SuccessMessage>
    )
  }

  return (
    <StyledForm onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="email">Email Address</label>
        <input
          id="email"
          type="email"
          name="email"
          placeholder="your.email@example.com"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          placeholder="Your message..."
          required
        />
      </div>

      {status === "ERROR" && (
        <ErrorMessage>
          There was an error submitting the form. Please try again.
        </ErrorMessage>
      )}

      <button type="submit" disabled={submitting}>
        {submitting ? "Sending..." : "Send Message"}
      </button>
    </StyledForm>
  )
}

export default ContactForm
